import { Contest } from '@/interfaces/contest';
import { EntityResource } from './entity.resource';

/**
 * Resource konkursów
 *
 * @export
 * @class ContestResource
 * @extends {EntityResource<Contest>}
 */
export class ContestResource extends EntityResource<Contest> {
  public listVariables = { filters: 'ContestFilters' };

  public getFields = {
    id: true,
    name: true,
    type: true,
    level: true,
    declination: true
  };

  public listFields = {
    id: true,
    name: true,
    type: true,
    level: true,
    declination: true
  };

  constructor() {
    super({
      entityName: 'contest'
    });
  }
}

export const contestResource = new ContestResource();
